// Planner User Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import Avatar from '../../common/avatar/avatar.jsx'
import PlannerDateRange from '../planner_daterange/planner_daterange.jsx'
import PlannerKanBanItem from '../planner_kanbanitem/planner_kanbanitem.jsx'
import PopoverPlannerHour from '../../popover/popover_planner_hour/popover_planner_hour.jsx'

class PlannerUser extends Component {
  constructor (props) {
    super(props)

    this._references = {
      popoverPlannerHour: React.createRef()
    }
  }

  static get propTypes () {
    return {
      user: PropTypes.object,
      viewMode: PropTypes.oneOf(['day', 'week', 'kanban']),
      onChangeHour: PropTypes.func,
      getTaskHours: PropTypes.func,
      showAvailableInfo: PropTypes.bool,
      showPlannedInfo: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      user: null,
      viewMode: 'day',
      onChangeHour: null,
      getTaskHours: null,
      showAvailableInfo: false,
      showPlannedInfo: false
    }
  }

  shouldComponentUpdate (nextProps, _nextState) {
    const { user, viewMode } = this.props
    if (!_.isEqual(user, nextProps.user) || viewMode !== nextProps.viewMode) {
      return true
    }
    return false
  }

  render () {
    const {
      user,
      viewMode,
      showAvailableInfo,
      showPlannedInfo,
      onChangeHour
    } = this.props
    const kanbanInfo = user.kanbanInfo || {}

    return (
      <div className='planner-user'>
        <div className='usercont'>
          <div className='titleinfo'>
            <div className='imagecont'>
              <Avatar imageUrl={user.imageUrl} type='big' />
            </div>
            <div className='titlecont'>
              <div className='title'>{user.displayName}</div>
              {user.functions && (
                <div className='subtitle'>{user.functions}</div>
              )}
            </div>
          </div>
          <div className={`dateinfo${user ? ' kanbanuser' : ''}`}>
            {viewMode === 'kanban' ? (
              <>
                <PlannerKanBanItem
                  key='todo'
                  type='todo'
                  title='plannerv2.planner.taskInfoTitleTodo'
                  count={kanbanInfo.countTodo}
                />
                <PlannerKanBanItem
                  key='inprogress'
                  type='inprogress'
                  title='plannerv2.planner.taskInfoTitleInProgress'
                  count={kanbanInfo.countInProgress}
                />
                <PlannerKanBanItem
                  key='completed'
                  type='completed'
                  title='plannerv2.planner.taskInfoTitleDone'
                  count={kanbanInfo.countCompleted}
                />
              </>
            ) : (
              <PlannerDateRange
                items={user.dayItems}
                showHour
                isWeekMode={viewMode === 'week'}
                onShowHour={this._onShowHour} // eslint-disable-line react/jsx-handler-names
                onChange={onChangeHour}
                isUserMode
                showAvailableInfo={showAvailableInfo}
                showPlannedInfo={showPlannedInfo}
              />
            )}
          </div>
        </div>
        <PopoverPlannerHour
          container={this}
          ref={this._references.popoverPlannerHour}
          onChangeHour={onChangeHour}
          onReload={this._onReload} // eslint-disable-line react/jsx-handler-names
        />
      </div>
    )
  }

  _onShowHour = (date, itemIdx) => {
    const { user, getTaskHours } = this.props

    if (this._references.popoverPlannerHour.current && getTaskHours) {
      getTaskHours(null, user.id, date, null, activities => {
        const dateItemWidth = 32

        window.setTimeout(() => {
          this._references.popoverPlannerHour.current.show(
            activities,
            date,
            0,
            itemIdx * dateItemWidth
          )
        }, 300)
      })
    }
  }

  _onReload = (date, callback) => {
    const { user, getTaskHours } = this.props
    getTaskHours(null, user.id, date, null, callback)
  }
}

export default PlannerUser
